import { createSelector } from 'reselect'
import config from 'constants/config'
import { LAST_MINUTE_REGIONS_LIST } from 'constants/config/region'

export const isLastMinuteEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (currentRegionCode) => !!(config.LAST_MINUTE_ENABLED && LAST_MINUTE_REGIONS_LIST.includes(currentRegionCode)),
)
